// // services/Rmstock.Services.js
// import axiosClient from '../configs/axios'; 

// class RmStockServices {
//   async getRmStockList({ plant_id,from_date,to_date }) {
//     try {
//       const headers = {
//         'aseapi': 'your-aseapi-token-here', // Replace with actual token
//         'Content-Type': 'application/json',
//       };

//       const response = await axiosClient.get(
//         `/reports/RM?plant_id=${plant_id}&from_date=${from_date}&&to_date=${to_date}`,
//         { headers }
//       );

//       return response.data; 
//     } catch (error) {
//       console.error('Error fetching RM stock list:', error);
//       throw error;
//     }
//   }
// }

// export default new RmStockServices();

// services/Rmstock.Services.js
// Fetches RM Stock data from tgpl_tracking.rm_stock via GET /reports/RMStock
import axiosClient from '../configs/axios';

class RmStockServices {
  /**
   * @param {object} params
   *   plant_id   – required
   *   from_date  – YYYY-MM-DD
   *   to_date    – YYYY-MM-DD
   */
  async getRmStockList({ plant_id, from_date, to_date }) {
    try {
      const response = await axiosClient.get(
        `/reports/RMStock?plant_id=${plant_id}&from_date=${from_date}&to_date=${to_date}`
      );
      return response.data;
    } catch (error) {
      console.error('[RmStockServices] Error fetching RM stock:', error);
      throw error;
    }
  }
}

export default new RmStockServices();